
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basePath/hub/[hub]",
      function () {
        return require("private-next-pages/basePath/hub/[hub]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basePath/hub/[hub]"])
      });
    }
  